<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>机构分销</a-breadcrumb-item>
    <a-breadcrumb-item>星图达人库</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <!-- 昵称 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">星图号：</a-col>
          <a-col :span="18">
            <a-input
              class="tool-item"
              v-model:value="xtAuthorIdModel"
              placeholder="请输入"
            />
          </a-col>
        </a-row>
      </a-col>
      <!-- 账号状态 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">机构：</a-col>
          <a-col :span="18">
            <a-select
              show-search
              class="tool-item"
              v-model:value="providerIdModel"
              placeholder="请选择"
              :filter-option="filterOption"
            >
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option v-for="item in agencies" :key="item.name" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 操作 -->
      <a-col :span="4">
        <a-row>
          <a-col :span="5" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap;">
            <a-button type="primary" @click="touchSearch">查询</a-button>
            <a-button style="margin-left: 16px; margin-right: 16px;" @click="touchReset">重置</a-button>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="8">
        <a-row>
          <a-col :span="18" class="tool-title"></a-col>
          <a-col :span="6" style="white-space: nowrap;">
            <a-button type="primary" @click="addDouyin"><PlusOutlined />添加抖音号</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
  <!-- 列表 -->
  <a-table
    :data-source="dataSource"
    :columns="columns"
    :pagination="pagination"
    :row-key="record => record.id"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 入库日期 -->
      <template v-if="column.key === 'date'">
        <a-tooltip>
          <template #title>{{ record[column.key] }}</template>
          {{ record[column.key] || '-' }}
        </a-tooltip>
      </template>
      <!-- 操作 -->
      <template v-else-if="column.key === 'operation'">
        <a class="operation-item" @click="touchEdit(record)">编辑</a>
        <a class="operation-item" @click="touchLink(record)">数据链接</a>
      </template>
      <template v-else>
        {{ record[column.key] || '-' }}
      </template>
    </template>
  </a-table>
  <!-- 新增、编辑弹窗 -->
  <Add ref="RefAdd" @success="getList" />

</template>

<script setup>
import { ref, reactive, nextTick, onBeforeMount } from 'vue'
import { message, Modal } from 'ant-design-vue'
import Add from './components-copyright-holder/Add.vue'
import { talentList, agencyList } from '@/api/agency'
import Pub from '@/utils/public'

// 打款信息
let RefBinding = ref(null)
// 昵称（星图ID检索）
let xtAuthorId = ref(undefined)
let xtAuthorIdModel = ref(undefined)
// 机构筛选
let providerId = ref(undefined)
let providerIdModel = ref(undefined)
// 新增
let RefAdd = ref(null)
// 团长ID
// let leaderid = ref(undefined) 
// let leaderidModel = ref(undefined) 
// 账号状态
let state = ref(undefined) 
let stateModel = ref(undefined) 
// 数据源
let dataSource = ref(null)
// 加载
let isLoading = ref(false)
// 客户端
let RefClient = ref(null)
// 机构列表
let agencies = ref([])
// 表头
let columns = reactive([
  {
    title: '达人ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '星图ID',
    dataIndex: 'xt_author_id',
    key: 'xt_author_id',
  },
  {
    title: '抖音号名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '归属团长',
    dataIndex: 'leader_name',
    key: 'leader_name',
  },
  {
    title: '归属机构',
    dataIndex: 'provider_name',
    key: 'provider_name',
  },
  {
    title: '入库日期',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])
// 分页
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})

// 钩子函数 - onBeforeMount
onBeforeMount(() => {
  // 初始化选择项列表
  getSelectList()
  // 获取列表
  getList()
})

// 初始化选择项列表
function getSelectList () {
  // 获取机构列表（不使用 agencySearch）
  agencyList({ page: 1, page_size: 500 }).then(res => {
    console.log('[XintuTalent] agencyList response:', res)
    const { code, data, msg } = res
    if (code === 0) {
      agencies.value = data?.data || []
    } else {
      message.error(res.message || msg)
    }
  })
}

// 绑定视频号
function touchBinding(record) {
  RefBinding.value.showDrawer(record)
}

// 数据链接
function touchLink(record) {
  Pub.COPY(`【${record.name}】星图达人链接：${Pub.DOMAIN_NAME()}/summary-data?type=1&id=${record.xt_author_id}`)
}

// 查询
function touchSearch () {
  // 调整参数
  xtAuthorId.value = xtAuthorIdModel.value
  providerId.value = providerIdModel.value
  pagination.current = 1
  // 获取列表
  getList()
}

// 重置
function touchReset () {
  xtAuthorId.value = undefined
  xtAuthorIdModel.value = undefined
  providerId.value = undefined
  providerIdModel.value = undefined
  // 初始化获取
  touchSearch()
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 表格change
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 获取列表
function getList () {
  isLoading.value = true
  const params = {
    page: pagination.current,
    page_size: pagination.pageSize,
    provider_id: providerId.value,
    xt_author_id: xtAuthorId.value
  }
  console.log('[XintuTalent] talentList params:', params)
  talentList(params).then(res => {
    isLoading.value = false
    console.log('[XintuTalent] talentList response:', res)
    const { code, msg, data } = res
    if (code === 0) {
      const list = data.data
      dataSource.value = list
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 禁用/启用
function touchEnable (record, state) {
  Modal.confirm({
    title: `确定${state ? '启用' : '禁用'}吗?`,
    onOk() {
      darenEnable({uid: record.uid, status: state}).then(res => {
        const { code } = res
        if (code === 0) {
          message.success('操作成功')
          getList()
        } else {
          message.error(res.message ?? '操作失败')
        }
      })
    },
  });
}

// 添加抖音号
function addDouyin () {
  RefAdd.value.showDrawer({})
}

// 编辑
function touchEdit (record) {
  RefAdd.value.showDrawer(record)
}
</script>

<style scoped>
.tool-view {
  width: 100%;
  display: flex;
  align-items: center;
}
.table-view {
  margin-top: 30px;
}
.tool-title:not(:first-child) {
  margin-left: 16px;
}
</style>